import { render, staticRenderFns } from "./TermsCheckbox.vue?vue&type=template&id=d56ad1ec&scoped=true&"
import script from "./TermsCheckbox.vue?vue&type=script&lang=js&"
export * from "./TermsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TermsCheckbox.vue?vue&type=style&index=0&id=d56ad1ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56ad1ec",
  null
  
)

export default component.exports